import { FormControlLabel, Switch } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

interface CustomSwitchProps {
  label?: React.ReactNode;
  onChange?: (checked: boolean) => void;
  value: boolean;
  customCssClass?: string;
  disabled?: boolean;
}

const useStyles = makeStyles({
  label: {
    marginLeft: 0,
    height: 48,
  },
});

export const CustomSwitch: React.FunctionComponent<CustomSwitchProps> = ({
  onChange,
  customCssClass,
  value,
  label,
  disabled,
}) => {
  const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => onChange!(checked);
  const classes = useStyles();

  return (
    <FormControlLabel
      className={`${classes.label} ${customCssClass}`}
      control={<Switch color="primary" checked={value} onChange={handleSwitchChange} disabled={disabled} />}
      label={label}
      labelPlacement="start"
    />
  );
};

CustomSwitch.defaultProps = {
  onChange: () => {},
} as Partial<CustomSwitchProps>;

export default CustomSwitch;
